"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SectionItem;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
const Container = /*#__PURE__*/(0, _react2.styled)("section")({
  name: "Container",
  class: "pl-c1fyj2r0",
  vars: {
    "c1fyj2r0-0": [({
      padding,
      indented
    }) => {
      if (!indented) {
        return 'var(--layout-vert-desktop) 0px 0px 0px';
      } else if (padding === 'none') {
        return '0px';
      } else if (padding === 'small' || padding === 'large') {
        return 'var(--layout-vert-base) var(--layout-rail-base)';
      } else if (padding === 'medium') {
        return `${_patternLibraryUtils.density['6']}`;
      }
      return 'initial';
    }],
    "c1fyj2r0-1": [({
      margin
    }) => {
      if (margin === 'none') {
        return '0px';
      } else if (margin === 'small') {
        return 'var(--layout-vert-base)';
      } else if (margin === 'large') {
        return 'var(--layout-vert-base)';
      }
      return 'initial';
    }],
    "c1fyj2r0-2": [({
      textAlign
    }) => textAlign === 'center' ? textAlign : `flex-${textAlign}`],
    "c1fyj2r0-3": [({
      textAlign
    }) => textAlign],
    "c1fyj2r0-4": [({
      rounded
    }) => rounded ? '8px' : 'unset'],
    "c1fyj2r0-7": [({
      padding,
      indented
    }) => {
      if (!indented) {
        return 'var(--layout-vert-desktop) 0px 0px 0px';
      } else if (padding === 'none') {
        return '0px';
      } else if (padding === 'small') {
        return 'var(--layout-vert-base) var(--layout-rail-base)';
      } else if (padding === 'medium') {
        return _patternLibraryUtils.density['12'];
      } else if (padding === 'large') {
        return 'var(--layout-vert-tabletLg) --layout-rail-tabletLg)';
      }
      return 'inherit';
    }],
    "c1fyj2r0-8": [({
      margin
    }) => {
      if (margin === 'none') {
        return '0px';
      } else if (margin === 'small') {
        return 'var(--layout-vert-base)';
      } else if (margin === 'large') {
        return 'var(--layout-vert-tabletLg)';
      }
      return 'inherit';
    }],
    "c1fyj2r0-10": [({
      padding,
      indented
    }) => {
      if (!indented) {
        return 'var(--layout-vert-desktop) 0px 0px 0px';
      } else if (padding === 'none') {
        return '0px';
      } else if (padding === 'small') {
        return 'var(--layout-vert-base) var(--layout-rail-base)';
      } else if (padding === 'medium') {
        return _patternLibraryUtils.density['12'];
      } else if (padding === 'large') {
        return 'var(--layout-vert-desktopLg) --layout-rail-desktopLg)';
      }
      return 'inherit';
    }],
    "c1fyj2r0-11": [({
      margin
    }) => {
      if (margin === 'none') {
        return '0px';
      } else if (margin === 'small') {
        return 'var(--layout-vert-base)';
      } else if (margin === 'large') {
        return 'var(--layout-vert-desktopLg)';
      }
      return 'inherit';
    }]
  }
});

/**
 * @ignore @typedef {import('csstype').Property.TextAlign} TextAlign
 * @ignore @typedef {import('csstype').Property.BackgroundImage} BackgroundImage
 * @ignore @typedef {import('csstype').Property.BackgroundColor} BackgroundColor
 */
/**
 * Render section with content alignment.
 * @module SectionItem
 *
 * @param {Object} props React props
 * @param {React.ReactElement|React.ReactElement[]} props.children content of section.
 * @param {string} props.dataCy data-cy attribute
 * @param {BackgroundImage} [props.backgroundImage] Image url
 * @param {BackgroundColor} [props.backgroundColor] Background color
 * @param {TextAlign} [props.textAlign] Align start, center, end or initial
 * @param {String} props.margin margin enum
 * @param {String} props.padding padding enum
 * @param {String} props.className padding enum
 * @param {Object} props.style padding enum
 * @param {boolean} props.rounded padding enum
 * @returns {React.ReactElement} section element
 * @public
 */
function SectionItem({
  _name,
  children,
  dataCy = 'section-item',
  textAlign = 'start',
  backgroundColor,
  backgroundImage,
  padding,
  margin,
  className = '',
  style,
  rounded = false,
  indented
}) {
  return /*#__PURE__*/_react.default.createElement(Container, (0, _extends2.default)({
    margin: margin,
    padding: padding,
    indented: indented,
    className: className,
    "data-margin": margin,
    "data-padding": padding,
    textAlign: textAlign,
    style: {
      textAlign,
      backgroundImage,
      backgroundColor,
      ...style
    },
    "data-cy": dataCy,
    rounded: rounded
  }, (0, _patternLibraryUtils.create)(_name, false, true)), children);
}
SectionItem.propTypes = {
  ..._section.default.propTypes,
  rounded: _propTypes.default.bool,
  indented: _propTypes.default.bool,
  dataCy: _propTypes.default.string
};